<template>
  <div class="modal-content productselector-modal">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a product') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row" v-if="showLinkedProduct">
        <div class="col-xs-6">
          <div class="btn-group">
            <label>
              <input type="radio" name="linkedproducttype" v-model="linkedProductType" :value="0" :disabled="isReservableProduct"> {{ _('Included in product price') }}
            </label>
          </div>
        </div>
        <div class="col-xs-6">
          <div class="btn-group">
            <label>
              <input type="radio" name="linkedproducttype" v-model="linkedProductType" :value="1"> {{ _('Offered as extra') }}
            </label>
          </div>
        </div>
      </div>
      <div class="row multiplySelectors" style="margin-top: 15px" v-if="showMultiply">
        <div class="col-xs-12">
          <label>{{ _('Multiply the product count') }}</label>
          <div>
            <div>
              <label>
                <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="days"> {{ _('By the number of days') }}
              </label>
            </div>
            <div>
              <label>
                <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="participants"> {{ _('By the number of participants') }}
              </label>
            </div>
            <div>
              <label>
                <input type="checkbox" name="linkedproductmultiply" v-model="multiply" value="resources"> {{ _('By the number of resources') }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="showLinkedProduct || showMultiply">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="product">{{ _('Product') }}</label><br />
            <v-select :options="products" v-model="product" label="name" keys="['id', 'name']" :placeholder="_('Type to search products')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search products') }}</template>
              </template>
              <template v-slot:option="option">
                <div class="d-center">
                  <span>{{ option.id }}: {{ option.name }}<template v-if="useAllProducts && option.shopid !== shopId"> ({{ option.shopid }})</template></span><span class="item-type to-right">{{ formatType(option) }}</span>
                </div>
              </template>
              <template v-slot:selected-option="option">
                <div class="selected d-center">
                  {{ option.id }}: {{ option.name }}<template v-if="useAllProducts && option.shopid !== shopId"> ({{ option.shopid }})</template>
                </div>
              </template>
            </v-select>
          </div>
        </div>
      </div>
      <div style="height: 300px"></div>
    </div>
    <div class="modal-footer">
      <div class="flex-row space-between">
        <button class="btn btn-success" v-on:click="selectProduct"><i class="fa fa-fw fa-check"></i> {{ _('OK') }}</button>
        <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></button>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import constants from '~/lib/constants'
import formatters from '~/lib/formatters'

export default {
  props: ['selectedProducts', 'showLinkedProduct', 'useAllProducts', 'version'],
  mixins: [constants, formatters],
  data () {
    return {
      product: null,
      products: [],
      linkedProductType: 0,
      multiply: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    selectedProductIds () {
      return this.selectedProducts.map(l => l.id)
    },
    showMultiply () {
      return this.showLinkedProduct && this.linkedProductType === 0
    },
    isReservableProduct () {
      if (!this.product) {
        return false
      }
      return parseInt(this.product.type) === this.TYPE_RESERVABLE
    }
  },
  watch: {
    showMultiply: {
      handler(newValue) {
        this.loadProducts()
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectProduct () {
      if (this.showLinkedProduct) {
        this.$emit('selectProduct', {
          product: this.product,
          type: this.linkedProductType,
          multiply: this.multiply
        })
      } else {
        this.$emit('selectProduct', this.product)
      }
    },
    async loadProducts() {
      if (this.useAllProducts) {
        return this.loadAllProducts()
      }
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/products.json?simple=true&iSortingCols=1&iSortCol_0=2&sSortDir_0=asc' + (this.showMultiply ? '&sSearch_3=0' : '') + (this.version ? '&version=' + this.version : '') + '&apikey=' + this.apiKey)
      } catch(e) {}
      this.products = response.data.filter(product => {
        return this.selectedProductIds.indexOf(product.id) === -1 // Only list products that are not already added
      })
    },
    async loadAllProducts() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/allproducts.json?all=true' + (this.version ? '&version=' + this.version : '') + '&apikey=' + this.apiKey)
      } catch(e) {}
      this.products = response.data.filter(product => {
        return this.selectedProductIds.indexOf(product.source_id + '-' + product.shopid) === -1 // Only list products that are not already added
      })
    },
    formatType(product) {
      const cell = {
        getValue () {
          return product.type
        },
        getRow () {
          return {
            getData () {
              return product
            }
          }
        }
      }
      return this.productTypeFormatter()(cell)
    }
  },
  mounted () {
    this.loadProducts()
  }
}
</script>